<template>
  <div v-if="steps.length" class="c-base-steps">
    <nav class="c-base-steps__list" :class="`c-base-steps__${content}`">
      <a
        @click="goTo(step.route)"
        v-for="(step, index) in steps"
        :key="index"
        :class="{
          'c-base-steps--step-support': step.active,
          'c-base-steps--step-success': step.success,
        }"
        class="c-base-steps__step"
        href="#"
      >
        {{ step.step }}
      </a>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    content: String,
  },

  methods: {
    goTo(route) {
      if (route) this.$router.push(route)
    },
  },
}
</script>

<style lang="scss">
.c-base-steps {
  padding: 12px 32px;
  text-align: center;

  &__list {
    display: flex;
    position: relative;
    margin: 0 auto;
    padding: 24px 0 6px;
    max-width: 250px;
    border-bottom: 1px solid $gray-3;
    &:before {
      content: '';
      @include position(absolute, 10px, 0, 0, 0);
      margin: 0 auto;
      width: 50%;
      height: 2px;
      background-color: $gray-3;
    }
  }

  &__pix {
    max-width: 440px;
    border-bottom: unset !important;

    &:before {
      width: 75%;
    }
  }

  &__step {
    position: relative;
    flex: 1;
    color: $black;
    &:hover,
    &:focus {
      color: $black;
    }
    &:before {
      content: '';
      @include position(absolute, -22px, 0, 0, 0);
      margin: 0 auto;
      width: 18px;
      height: 18px;
      border: 1px solid $gray-4;
      border-radius: 100%;
      background-color: $white;
    }
  }

  &--step-support,
  &--step-success {
    color: $support;
    &:hover,
    &:focus {
      color: $support;
    }
    &:before {
      border-color: $support;
    }
    &:after {
      content: '';
      @include position(absolute, -16px, 0, 0, 0);
      margin: 0 auto;
      width: 6px;
      height: 6px;
      z-index: 1;
      border-radius: 100%;
      background-color: $support;
    }
  }

  &--step-success {
    color: $success;
    &:hover,
    &:focus {
      color: $success;
    }
    &:before {
      border-color: $success;
    }
    &:after {
      background-color: $success;
    }
  }
}
</style>
